import React, { useState } from "react";
import styled, { css } from "styled-components";
import { ReactComponent as At } from "../assets/svg/at.svg";
import { ReactComponent as Eye } from "../assets/svg/eye.svg";
import { ReactComponent as EyeLock } from "../assets/svg/eye-lock.svg";
import Button from "./Button";
import Notification from "./Notification";
import Input from "./Input";
import { Link } from "react-router-dom";
import UserAPI from "../apis/UserAPI";
import { isValidEmail } from "../helpers/validators";
import ShortMessage from "./ShortMessage";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);

  const [showNewPassword, setShowNewPassword] = useState(false);

  const signIn = () => {
    if (loading) return;

    setLoading(true);

    const sanitized = {
      email: email.replace(/\s/g, "").toLowerCase(),
      password,
    };

    if (temp.some((v) => v === sanitized.email)) {
      setShowNewPassword(true);
    }

    let notification = null;

    if (!isValidEmail(sanitized.email))
      notification = "El correo es incorrecto.";
    else if (sanitized.password === "")
      notification = "La contraseña es incorrecta.";

    if (notification) {
      setNotification(notification);
      setLoading(false);
    } else {
      setNotification(null);
      UserAPI.login(sanitized.email, sanitized.password).catch((error) => {
        setNotification(error);
        setLoading(false);
      });
    }
  };

  return (
    <div className="h-screen flex">
      {showNewPassword && (
        <ShortMessage
          message={`Tu nueva contraseña es 123123123. Cámbiala de inmediato!\n\nSi ya lo cambiaste, ignora este mensaje.`}
          onAccept={() => setShowNewPassword(false)}
        />
      )}
      <div className="m-auto flex flex-col p-4 w-full  max-w-[350px]">
        <Logo src="logo.png" className="self-center" />
        {notification && <NotificationStyled message={notification} />}
        <InputStyled
          placeholder="Correo"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          icon={<InputIcon as={At} />}
        />
        <InputStyled
          placeholder="Contraseña"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type={showPassword ? "text" : "password"}
          icon={
            password.length > 0 && (
              <InputIcon
                button
                as={showPassword ? EyeLock : Eye}
                onClick={() => setShowPassword((state) => !state)}
              />
            )
          }
        />
        <ButtonStyled
          text="Iniciar sesión"
          onClick={signIn}
          loading={loading}
          primary
        />
        <Label as={Link} to="/recover" right>
          ¿Necesitas ayuda?
        </Label>
        <Footer className="flex items-center justify-center w-full">
          <Label as={Link} to="/register" className="p-3">
            ¿Primera vez en RaDi? <strong>Subscríbete.</strong>
          </Label>
        </Footer>
      </div>
    </div>
  );
};

const temp = [
  "brendameg21@gmail.com",
  "jairgerardomalpartidaalvites@gmail.com",
  "c.alv.ve@gmail.com",
  "phao_kpop@hotmail.com",
  "franco_md_1792@hotmail.com",
  "carlosagustin@masiasweb.com",
  "jocsancasanovasaucedo@gmail.com",
  "bellidojh@gmail.com",
  "myspiritsanty54@gmail.com",
  "miguelbarragan1829@gmail.com",
  "lizbel_27m@hotmail.com",
  "lizaparedes@gmail.com",
  "torymar_mm@hotmail.com",
  "leonardo_803@hotmail.com",
  "crismarpabon@gmail.com",
  "saraportal98@gmail.com",
  "herdil95@gmail.com",
  "christell.gt97@gmail.com",
  "karla.soto.colan@outlook.com",
  "egomurus@gmail.com",
  "mendoza.transilvia@gmail.com",
  "gerardo8217@hotmail.com",
  "ailyngarciavedia@gmail.com",
  "gilber001@gmail.com",
  "nilda.rengifo2@gmail.com",
  "nars.josue@gmail.com",
  "jessenwanger@gmail.com",
  "renatomendozafranco@hotmail.com",
  "joaquin.emir@gmail.com",
  "maulap15@gmail.com",
  "alejandra.sanmiguelbarrantes@gmail.com",
  "aybyurcia@gmail.com",
  "maecotrina@gmail.com",
  "giancarlo.montenegro.rojas@gmail.com",
  "vbell.713@gmail.com",
  "montenegropiero@gmail.com",
];


const Container = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`;

const NotificationStyled = styled(Notification)`
  margin: 0px 0px 20px 0px;
`;

const InputStyled = styled(Input)`
  margin-bottom: 10px;
`;

const Wrapper = styled.div`
  margin: auto 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 270px;
  width: 100%;

  padding: 5px;
  box-sizing: border-box;
`;

const InputIcon = styled.div`
  padding: 8px 10px;
  min-width: 18px;
  min-height: 18px;
  width: 18px;
  height: 18px;
  margin: auto 0;
  fill: rgba(0, 0, 0, 0.5);

  ${(props) =>
    props.button &&
    css`
      cursor: pointer;
    `}
`;

const ButtonStyled = styled(Button)`
  margin: 15px 0px;
  width: 100%;
`;

const Label = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  text-align: center;
  padding: 8px 10px;
  font-size: 0.9em;
  margin: 5px 0px;

  color: black;

  ${(props) =>
    props.right &&
    css`
      margin: 0 0 0 auto;
    `}
`;

const Footer = styled.div`
  margin-top: 30px;
`;

const Logo = styled.img`
  width: 130px;
  height: 130px;

  margin-bottom: 30px;
`;

export default Login;
